var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "zoom", mode: "in-out" } }, [
    _vm.visible
      ? _c("section", [
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "header" },
              [
                _vm.icon
                  ? _c("img", {
                      attrs: {
                        src: _vm.iconSrc,
                        height: _vm.iconSize,
                        alt: _vm.iconAlt
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.title ? _c("h1", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
                _vm._v(" "),
                _vm._t("header")
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "body" }, [_vm._t("body")], 2)
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2020567a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2020567a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Dialog.vue
// module id = null
// module chunks = 